import ikpReducer from "./reducers";

export default ikpReducer